export default {
  //Sponsor
  sponsorName: 'IDRA',
  sponsorWeb: 'http://flow-idra.com',
  sponsorDescription: 'Description Optional...',
  sponsorSearchBy: 'Sponsor Name',
};
